import Info from 'components/Modal/Info';

import * as modalTypes from './constants';

export default {
  [modalTypes.MODAL_INFO]: Info,
};
